import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';

import { HpRespPromoModulePromoItemOld } from './HpRespPromoModulePromoItemOld';
import { HpRespModuleContainerOld } from '../HpRespModuleContainerOld/HpRespModuleContainerOld';
import { trackPromoImpressions, trackPromoClick } from './helpers/PromoTrackingOld';
import { SharedInViewport } from '../../sharedComponents/SharedInViewport';

class HpRespPromoModulePrimaryOldComponent extends Component {
    promoPrimaryModule = get(this.props, 'homepage.promoPrimaryModule');

    handleInitialDisplay = ({ inViewport }) => {
        if (this.promoPrimaryModule && inViewport) {
            const { items } = this.promoPrimaryModule;
            trackPromoImpressions({ items, startingIndex: 0 });
        }
    };

    render() {
        if (!this.promoPrimaryModule) {
            return null;
        }

        const { title, items } = this.promoPrimaryModule;

        return (
            <HpRespModuleContainerOld>
                <HpRespModuleContainerOld.Header>
                    {title ? (
                        title
                    ) : (
                        <FormattedMessage
                            id="homepage.modules.promo.primary.old.title"
                            defaultMessage="Curated Weekly"
                        />
                    )}
                </HpRespModuleContainerOld.Header>
                <SharedInViewport stopWhenInViewport onInViewportChange={this.handleInitialDisplay}>
                    <div className="rowFlex">
                        {items.map((promotion, index) => (
                            <HpRespPromoModulePromoItemOld
                                key={promotion.cmsId}
                                promotion={promotion}
                                className={items.length === 1 ? 'colXs12' : 'colLg6 colXs12'}
                                onClick={() => trackPromoClick({ item: promotion, index })}
                            />
                        ))}
                    </div>
                </SharedInViewport>
            </HpRespModuleContainerOld>
        );
    }
}

HpRespPromoModulePrimaryOldComponent.propTypes = {
    homepage: PropTypes.object,
};

export const HpRespPromoModulePrimaryOld = createFragmentContainer(
    HpRespPromoModulePrimaryOldComponent,
    {
        homepage: graphql`
            fragment HpRespPromoModulePrimaryOld_homepage on Homepage {
                promoPrimaryModule: module(type: "promoPrimary") {
                    ... on PromoModule {
                        title
                        items {
                            cmsId
                            imageCopy
                            cta
                            imageUrl @skip(if: $isMobile)
                            mobileImageUrl @include(if: $isMobile)
                            linkData {
                                # path is used in PromoTrackingOld.js
                                path
                                ...SeoLink_linkData
                            }
                        }
                    }
                }
            }
        `,
    }
);
